import moment from 'moment';
import React, { useCallback, useMemo } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import { IoCalendarClearOutline } from 'react-icons/io5';
import Select from 'react-select';
const Budget2 = ({ formData, setFormData, handleAddColumn, attributeOptions, extraBudgetTime, handleToggle, handleChange, handleDeleteColumn, handleAttributeChange1budget2, valueOptions1budget2, handleAttributeChange2budget2, valueOptions2budget2, additional, handleToggleCampagin, extraBudgetCampaign }) => {
    const CustomDateInput = ({ value, onClick }) => (
        <div className="input-group">
            <span className="input-group-text" onClick={onClick} style={{ cursor: "pointer" }}>
                <IoCalendarClearOutline size={20} />
            </span>
            <input
                type="text"
                className="form-control"
                value={value}
                onClick={onClick}
                readOnly
                placeholder="Select Date"
            />
        </div>
    );
    const campaignOptions = useMemo(() =>
        additional?.campaigns?.map(campaign => ({ value: campaign, label: campaign })),
        [additional]
    );
    const formatLocalDate = (date) => {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
    };

    const handleCampaignChange = useCallback((selectedOptions, index) => {
        const selectedCampaigns = selectedOptions.map(option => option.value);
        const updatedBudget = [...formData.extraBudget];
        updatedBudget[index].value = selectedCampaigns;
        setFormData(prev => ({
            ...prev,
            extraBudget: updatedBudget
        }));
    }, [formData.extraBudget, setFormData]);
    return (
        <div className="px-2">
            <Row className="border py-2 gy-2 justify-content-center">
                <Col sm={6}>
                    <Form.Group controlId="formAttribute1">
                        <Form.Label className="text-secondary mb-0">Select Column Name 1</Form.Label>
                        <Form.Select
                            as="select"
                            placeholder='Select Column'
                            value={formData?.budget2?.name}
                            onChange={handleAttributeChange1budget2}
                        >
                            <option value="">Select Column</option>
                            {attributeOptions?.map(attr => (
                                <option key={attr?.value} value={attr?.value}>{attr?.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col sm={6}>
                    <Form.Group controlId="formValue1">
                        <Form.Label className="text-secondary mb-0">Select Column Value 1</Form.Label>
                        <Form.Select as="select"
                            placeholder='Select Column Value'
                            value={formData?.budget2?.value} onChange={e => setFormData(prev => ({
                                ...prev, budget2: { ...prev?.budget2, value: e.target.value }
                            }))} disabled={!formData?.budget2?.name}>
                            <option value="">Select Value</option>
                            {valueOptions1budget2?.map(val => (
                                <option key={val.value} value={val.value}>{val.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Row className="mt-2 justify-content-center align-items-center gy-2">
                    <Col sm={3}>
                        <p className="text-secondary text-md-end text-center form-label mb-0 pb-0">Multiply By(*)</p>
                    </Col>
                    <Col sm={3}>
                        <Form.Group controlId="formCount">
                            <Form.Label className="text-secondary mb-0">Count </Form.Label>
                            <Form.Control type="number" value={formData?.budget2?.count} onChange={e => setFormData(prev => ({
                                ...prev, budget2: { ...prev?.budget2, count: e.target.value }
                            }))} />
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group controlId={`selectOption-metric1`}>
                            <Form.Label className="text-secondary mb-0">Select Option for Event Column1</Form.Label>
                            <Form.Select
                                value={formData?.budget2?.select1}
                                onChange={(e) => setFormData(prev => ({
                                    ...prev,
                                    budget2: {
                                        ...prev.budget2,
                                        select1: e.target.value
                                    }
                                }))}>
                                <option value="count">Count</option>
                                <option value="sum">Sum</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {/* <Col sm={3}>
                <p className="text-secondary text-md-start text-center form-label mb-0 pb-0">Adding In(+)</p>
            </Col> */}
                </Row>
                <Row className="mt-2 justify-content-center align-items-center gy-2">
                    <Col sm={3}>
                        <p className="text-secondary text-md-end text-center form-label mb-0 pb-0">Adding In(+)</p>
                    </Col>
                    <Col sm={4}>
                        <Form.Group controlId="formAttribute">
                            <Form.Label className="text-secondary mb-0">Select Column Name 2</Form.Label>
                            <Form.Select
                                as="select"
                                placeholder='Select Column'
                                value={formData?.budget2?.name2}
                                onChange={handleAttributeChange2budget2}
                            >
                                <option value="">Select Column 2</option>
                                {attributeOptions?.map(attr => (
                                    <option key={attr?.value} value={attr?.value}>{attr?.label}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col sm={5}>
                        <Form.Group controlId="formValue">
                            <Form.Label className="text-secondary mb-0">Select Column Value 2</Form.Label>
                            <Form.Select as="select"
                                placeholder='Select Column Value 2'
                                value={formData?.budget2?.value2} onChange={e => setFormData(prev => ({
                                    ...prev, budget2: { ...prev?.budget2, value2: e.target.value }
                                }))} disabled={!formData?.budget2?.name2}>
                                <option value="">Select Value 2</option>
                                {valueOptions2budget2?.map(val => (
                                    <option key={val.value} value={val.value}>{val.label}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Row className="mt-2 justify-content-center align-items-center gy-2">
                        <Col sm={3}>
                            <p className="text-secondary text-md-end text-center form-label mb-0 pb-0">Multiply By(*)</p>
                        </Col>
                        <Col sm={2}>
                            <Form.Group controlId="formCount">
                                <Form.Label className="text-secondary mb-0">Count 2</Form.Label>
                                <Form.Control type="number" value={formData?.budget2?.count2} onChange={e => setFormData(prev => ({
                                    ...prev, budget2: { ...prev?.budget2, count2: e.target.value }
                                }))} />
                            </Form.Group>
                        </Col>
                        <Col sm={5}>
                            <Form.Group controlId={`selectOption-metric2`}>
                                <Form.Label className="text-secondary mb-0">Select Option for Event Column2</Form.Label>
                                <Form.Select
                                    value={formData?.budget2?.select2}
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        budget2: {
                                            ...prev.budget2,
                                            select2: e.target.value
                                        }
                                    }))}>
                                    <option value="count">Count</option>
                                    <option value="sum">Sum</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col sm={2}>
                            <Form.Group controlId="formCurrency">
                                <Form.Label className="text-secondary mb-0">Currency</Form.Label>
                                <Form.Select value={formData?.budget2?.currency} onChange={e => setFormData(prev => ({
                                    ...prev, budget2: { ...prev?.budget2, currency: e.target.value }
                                }))}>
                                    <option value="€">Euro</option>
                                    <option value="$">USD</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                </Row>
                <Row className="mt-3 justify-content-center align-items-center">
                    <Col sm={3}>
                        <Form.Check
                            type="switch"
                            id="extraBudgetTime"
                            label="Enable Budget by Date"
                            checked={extraBudgetTime}
                            onChange={handleToggle}
                        />
                    </Col>
                    <Col md={4}>
                        <Form.Check
                            type="switch"
                            id="extraBudgetCampaign"
                            label="Enable Budget by Campagin"
                            checked={extraBudgetCampaign}
                            onChange={handleToggleCampagin}
                        />
                    </Col>
                </Row>

                {/* Extra Budget Date & Count Inputs */}
                {extraBudgetTime &&
                    <div className=''>
                        {formData?.extraBudget?.map((item, index) => (
                            <Row key={index} className="mt-3 justify-content-center align-items-end gap-md-0 gap-2 border mx-2 py-3 position-relative">
                                {extraBudgetCampaign && (
                                    <Col className='pb-3' sm={10}>
                                        <Form.Group controlId={`formCampaign-${index}`}>
                                            <Form.Label className="text-secondary mb-0">Select Campaign(s)</Form.Label>
                                            <Select
                                                isMulti
                                                options={campaignOptions}
                                                value={campaignOptions.filter(option => item.value?.includes(option.value))}
                                                onChange={(selectedOptions) => handleCampaignChange(selectedOptions, index)}
                                                closeMenuOnSelect={false}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                                {/* <Col sm={1}>
                                    <div className="text-end">{index + 1}.</div>
                                </Col> */}
                                <Col sm={3}>
                                    <Form.Group className="custom-calendar" controlId={`formTillDate-${index}`}>
                                        <Form.Label className="text-secondary mb-0 d-block">Select Budget Date from</Form.Label>
                                        <DatePicker
                                            selected={item.tillDate ? new Date(item.tillDate) : null}
                                            onChange={date => handleChange(index, "tillDate", formatLocalDate(date))}
                                            dateFormat="yyyy-MM-dd"
                                            customInput={<CustomDateInput />}
                                            calendarStartDay={1}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group controlId={`formExtraCount-${index}`}>
                                        <Form.Label className="text-secondary mb-0">
                                            Budget Multiply Count from Date {(item.tillDate ? moment(item.tillDate).format('ll') : "")}
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={item.count}
                                            onChange={e => handleChange(index, "count", e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group controlId="formExtraCount2">
                                        <Form.Label className="text-secondary mb-0">
                                            Budget Multiply Count2 from Date ({item.tillDate ? moment(item.tillDate).format('ll') : ""})
                                        </Form.Label>

                                        <Form.Control
                                            type="number"
                                            value={item.count2}
                                            onChange={e => handleChange(index, "count2", e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                {/* <Col sm={1} className="text-left">
                                    {index !== 0 && (
                                        <Button
                                            variant="danger"
                                            onClick={() => handleDeleteColumn(index)}
                                            className="border-0"
                                            style={{ padding: "5px 10px", fontSize: "14px" }}
                                        >
                                            ✖
                                        </Button>
                                    )}
                                </Col> */}
                                <div className='delete-date-div'>
                                    {index !== 0 && (
                                        <Button
                                            variant="danger"
                                            onClick={() => handleDeleteColumn(index)}
                                            className="border-0 delete-date-div rounded-0"
                                            style={{ padding: "5px 10px", fontSize: "14px" }}
                                        >
                                            ✖
                                        </Button>
                                    )}
                                </div>
                            </Row>
                        ))}
                        <div className='text-center'>
                            <Button
                                style={{ backgroundColor: 'var(--color1)', color: 'var(--color2)' }}
                                variant="primary"
                                onClick={handleAddColumn}
                                className="m-3 company-btn-hover border-0"
                            >
                                Add Date
                            </Button>
                        </div>
                    </div>
                }
            </Row>
        </div>
    )
}

export default Budget2
